export const SearchInventoryDetailPublish = () => {
    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">재고내역 검색</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-dark w-150px px-0">
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt="" />엑셀 내보내기
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label for="" className="form-label frm_label">상태</label>
                            <select className="form-select w-150px">
                                <option>출고</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="frm_row">
                            <label for="" className="form-label frm_label">재고변경일자</label>
                            <div className="frm_field">
                                <div className="frm_field input_date">
                                    <input type="date" className="form-control" />
                                    <span className="txt_range">~</span>
                                    <input type="date" className="form-control me-0" />
                                    <button className="btn btn-info btn_search">
                                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">재고 내역</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <div className="search_inv_section">
                    <div className="left">
                        <div className="inv_box blue">
                            <div className="inv_box_top">
                                <div className="inv_box_title"><img src={process.env.PUBLIC_URL + "/assets/images/icon_boxblue.png"} alt="" /> 출고</div>
                                <div className="inv_box_toolbar">
                                    <div className="inv_box_time">2024-10-30 <span>15:46</span></div>
                                    <button className="btn btn-link p-0">-</button>
                                </div>
                            </div>
                            <div className="inv_box_content">
                                <div className="line1">1품목/-1개</div>
                                <div className="line2">주식회사 000</div>
                                <div className="line3">S1-WIN Emb Compact 7 C7E</div>
                            </div>
                        </div>
                        <div className="inv_box">
                            <div className="inv_box_top">
                                <div className="inv_box_title"><img src={process.env.PUBLIC_URL + "/assets/images/icon_boxblue.png"} alt="" /> 출고</div>
                                <div className="inv_box_toolbar">
                                    <div className="inv_box_time">2024-10-30 <span>15:46</span></div>
                                    <button className="btn btn-link p-0">-</button>
                                </div>
                            </div>
                            <div className="inv_box_content">
                                <div className="line1">1품목/-1개</div>
                                <div className="line2">주식회사 000</div>
                                <div className="line3">S1-WIN Emb Compact 7 C7E</div>
                            </div>
                        </div>
                        <div className="inv_box">
                            <div className="inv_box_top">
                                <div className="inv_box_title"><img src={process.env.PUBLIC_URL + "/assets/images/icon_boxblue.png"} alt="" /> 출고</div>
                                <div className="inv_box_toolbar">
                                    <div className="inv_box_time">2024-10-30 <span>15:46</span></div>
                                    <button className="btn btn-link p-0">-</button>
                                </div>
                            </div>
                            <div className="inv_box_content">
                                <div className="line1">1품목/-1개</div>
                                <div className="line2">주식회사 000</div>
                                <div className="line3">S1-WIN Emb Compact 7 C7E</div>
                            </div>
                        </div>
                        <div className="inv_box">
                            <div className="inv_box_top">
                                <div className="inv_box_title"><img src={process.env.PUBLIC_URL + "/assets/images/icon_boxblue.png"} alt="" /> 출고</div>
                                <div className="inv_box_toolbar">
                                    <div className="inv_box_time">2024-10-30 <span>15:46</span></div>
                                    <button className="btn btn-link p-0">-</button>
                                </div>
                            </div>
                            <div className="inv_box_content">
                                <div className="line1">1품목/-1개</div>
                                <div className="line2">주식회사 000</div>
                                <div className="line3">S1-WIN Emb Compact 7 C7E</div>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        <div className="inv_box lg">
                            <div className="inv_box_top">
                                <div className="inv_box_title">출고내역</div>
                                <div className="inv_box_toolbar">
                                    <button className="btn btn-link p-0">-</button>
                                </div>
                            </div>
                            <div className="inv_box_content">
                                <div className="inner">
                                    <div className="inv_label">
                                        출고일<br />
                                        출고처
                                    </div>
                                    <div className="inv_data">
                                        2024-10-30 <span>15:46</span><br />
                                        <span>주식회사 000</span>
                                    </div>
                                </div>

                                <table className="table table-bordered my_table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "16.8%" }}>이미지</th>
                                            <th style={{ width: "56.03%" }}>제품 상세</th>
                                            <th style={{ width: "12.93%" }}>재고 변동</th>
                                            <th>수량</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="p-4px"><img src={process.env.PUBLIC_URL + "/assets/images/ex_image.png"} alt="" width={172} /></td>
                                            <td>
                                                <div className="line1">S1-WIN Emb Compact 7 C7E</div>
                                                <div className="line2">TNA-00022</div>
                                                <div className="line3">설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다.설명칸입니다.설명칸 설명칸</div>
                                            </td>
                                            <td className="text-center">8 &gt; 10</td>
                                            <td className="text-end"><span className="required">+</span>2</td>
                                        </tr>
                                        <tr className="blue">
                                            <td className="text-center"><span className="f-15">총 품목</span></td>
                                            <td><span className="f-15">1개 품목</span></td>
                                            <td className="text-center"></td>
                                            <td className="text-end"><span className="required">+</span>2</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}